module.exports = __webpack_public_path__ + "static/img/DCtu4@2x.ae071b36.png";